import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	mobileDeviceNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.mobile-device-non-final',
		defaultMessage: 'Mobile device',
		description: 'Table header for the mobile device list, mobile device name column',
	},
	appVersionNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.app-version-non-final',
		defaultMessage: 'App version',
		description: 'Table header for the mobile device list, installed app version column',
	},
	statusNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-non-final',
		defaultMessage: 'Status',
		description: 'Table header for the mobile device list, status column',
	},
	statusOnNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-on-non-final',
		defaultMessage: 'ON',
		description:
			'"on" value for status column (eoc-changeboarding.transition-home.notifications-step.card-one.duplicated-list.status-non-final)',
	},
	statusOffNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-off-non-final',
		defaultMessage: 'OFF',
		description:
			'"off" value for status column (eoc-changeboarding.transition-home.notifications-step.card-one.duplicated-list.status-non-final)',
	},
	duplicateButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.duplicate-button-non-final',
		defaultMessage: 'Add Jira Cloud app as notification method',
		description: 'Button to copy the notification methods for the selected mobile devices to JSM',
	},
	noSelectionNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.no-selection-non-final',
		defaultMessage:
			'No mobile devices selected. Select mobile devices to add Jira Cloud as the notification method.',
		description:
			'The message to be displayed when no items from the device list is selected when the button (eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.duplicate-button-non-final) is pressed.',
	},
});
